(function($){

  gsap.registerPlugin(ScrollTrigger)

  const textAnimation = () => {
  // headers and "the other" elements animating as 2 seperate entities
  const blocks = gsap.utils.toArray('.image-text, .cover-cta, .category-slider-info')

    blocks.forEach(block => {
      const header = gsap.utils.selector(block)('h2')
      const theRest = gsap.utils.selector(block)('p, .wp-block-buttons')
      gsap.set(header, {
        autoAlpha: 0,
        y: 50
      })
      gsap.to(header, {
        scrollTrigger:{
          trigger: block,
          start: 'top 70%',
        },
        autoAlpha: 1,
        y: 0,
        duration: 0.5,
      })

      gsap.set(theRest, {
        autoAlpha: 0,
        y: 50
      })

      gsap.to(theRest, {
        scrollTrigger:{
          trigger: block,
          start: 'top 50%',
        },
        autoAlpha: 1,
        y: 0,
        duration: 0.5,
      })

    })
  }

  const sliderLoading = () => {
    gsap.to('.inner-hero-slider-container', {
      opacity: 1,
      duration: 0.5,
      delay: 0.5
    })
  }

  sliderLoading()

  $('body').imagesLoaded( function() {
    textAnimation()
    ScrollTrigger.refresh()
  });

})(jQuery)